module.exports = __webpack_public_path__ + "img/logo.0fe1bbd0.svg";